import LenderPageTemplate from '@/components/shared/LenderPageTemplate'

const NorthridgePage = () => {
  return (
    <LenderPageTemplate
      lenderName="Northridge"
      slug="/lenders/mis-sold-northridge-car-finance"
      seoImage=""
      seoImageAlt=""
      aiOverview=""
    />
  )
}

export default NorthridgePage
